export interface DashboardAnalyticsSummary {
  generatedAt: string;
  rangeDays: number;
  totals: {
    visits: number;
    pageViews: number;
    events: number;
    uploads: number;
    conversions: number;
    downloads: number;
  };
  timeseries: DashboardTimeseriesPoint[];
  topPages: DashboardPageMetric[];
  topEvents: DashboardEventMetric[];
  topProfiles: DashboardProfileMetric[];
  formats: DashboardEventMetric[];
  recentEvents: DashboardRecentEvent[];
}

export interface DashboardTimeseriesPoint {
  date: string;
  visits: number;
  pageViews: number;
  events: number;
  conversions: number;
  downloads: number;
}

export interface DashboardPageMetric {
  path: string;
  title: string;
  count: number;
}

export interface DashboardEventMetric {
  name: string;
  count: number;
}

export interface DashboardProfileMetric {
  profileId: string;
  conversions: number;
  downloads: number;
  successCount: number;
}

export interface DashboardRecentEvent {
  id: string;
  name: string;
  path: string;
  timestamp: string;
  metadata: Record<string, string | number | boolean | null>;
}

export class DashboardAnalyticsService {
  async getSummary(rangeDays: number): Promise<DashboardAnalyticsSummary> {
    const params = new URLSearchParams({ days: String(rangeDays) });
    const response = await fetch(`/api/dashboard/analytics?${params}`, {
      credentials: 'same-origin',
    });

    if (!response.ok) {
      throw new Error('Не удалось загрузить аналитику dashboard.');
    }

    return (await response.json()) as DashboardAnalyticsSummary;
  }
}
